import getObjectKey from 'lib/object/getObjectKey'

function buildLoyaltySelectedUpgradeKey(
  originPackage: App.Package | App.HotelPackage,
  /**
   * @todo Room number should be included in the key to avoid overlaps.
   */
  // roomNumber: number,
): string | undefined {
  return getObjectKey({
    originUniqueKey: originPackage.uniqueKey,
    // roomNumber,
  })
}

export default buildLoyaltySelectedUpgradeKey
